export const truncateString = (str: string, max = 70): string => {
  if (str && str.length > max) {
    const shortened = str.substring(0, max)
    return `${shortened}...`
  }
  return str
}
